/**
 * Lazy loader for partytracks/client.
 *
 * partytracks pulls in WebRTC + rxjs machinery we only need on the Call screen,
 * so we load it on demand (mirrors the app's lazy `import('hls.js')` pattern in
 * VideoEmbedInnerWeb). The module promise is cached so repeated calls share one
 * download. `partytracks/react` exposes hooks (can't be lazy) and is imported
 * directly where needed -- it's small and tree-shakeable.
 */

import type * as PartyTracksModule from 'partytracks/client'
import {type PartyTracks as PartyTracksClass} from 'partytracks/client'

export type PartyTracks = PartyTracksClass
export type PartyTracksClientModule = typeof PartyTracksModule

let modPromise: Promise<PartyTracksClientModule> | null = null

/**
 * Resolves the partytracks/client module, downloading it on first call.
 */
export function loadPartyTracks(): Promise<PartyTracksClientModule> {
  if (!modPromise) {
    modPromise = import('partytracks/client')
  }
  return modPromise
}
